













































import { mapActions, mapState } from 'vuex';
import * as vr from '@/helpers/validation';
import { ConfirmationDialogData, OperatorBalance } from '@/api/schema';
import { fromPercents, toPercents } from '@/helpers/decimalsHelpers';
import ConfirmationDialog from '@/components/ConfirmationDialog.vue';
import { errorToastMessage } from '@/helpers/errorToastMessage';

export default {
  name: 'OperatorFeesSettings',
  components: {
    ConfirmationDialog
  },
  data(): any {
    return {
      confirmationDialogState: false,
      confirmationDialogData: {
        header: 'Are you sure to update Operator Fee?',
        okText: 'Save'
      } as ConfirmationDialogData,
      formData: {} as any,
      isFormValid: false,
      fieldsConfig: [
        {
          id: 'casinoRewardFee',
          valueKey: 'casinoRewardFee',
          activeKey: 'casinoRewardFeeActive',
          label: 'Casino Reward Fee, %'
        },
        {
          id: 'loyaltySwapFee',
          valueKey: 'loyaltySwapFee',
          activeKey: 'loyaltySwapFeeActive',
          label: 'Loyalty Swap Fee, %'
        },
        {
          id: 'p2eFee',
          valueKey: 'p2eFee',
          activeKey: 'p2eActive',
          label: 'P2E Fee, %'
        },
        {
          id: 'h2eFee',
          valueKey: 'h2eFee',
          activeKey: 'h2eActive',
          label: 'H2E Fee, %'
        },
        {
          id: 'promoRewardFee',
          valueKey: 'promoRewardFee',
          activeKey: 'promoRewardFeeActive',
          label: 'Promo Reward Fee, %'
        },
        {
          id: 'missionRewardFee',
          valueKey: 'missionRewardFee',
          activeKey: 'missionRewardFeeActive',
          label: 'Mission Reward Fee, %'
        },
        {
          id: 'redeemRewardFee',
          valueKey: 'redeemRewardFee',
          activeKey: 'redeemRewardFeeActive',
          label: 'Redeem Reward Fee, %'
        },
        {
          id: 'referralRewardFee',
          valueKey: 'referralRewardFee',
          activeKey: 'referralRewardFeeActive',
          label: 'Referral Reward Fee, %'
        },
        {
          id: 'dailyCheckinFee',
          valueKey: 'dailyCheckinFee',
          activeKey: 'dailyCheckinFeeActive',
          label: 'Daily Checkin Fee, %'
        }
      ],
      rules: [
        (v) => vr.required(v),
        (v) => vr.validNumber(v),
        (v) => vr.lte(v, 100)
      ]
    };
  },
  watch: {
    balance: {
      handler(newVal: OperatorBalance): void {
        this.formData = { ...newVal };
        this.$refs.form?.resetValidation();
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    ...mapState('OperatorPayments', ['loading', 'balance']),
    isValuesChanged(): boolean {
      return this.fieldsConfig.some((field: any) => {
        const isValueChanged =
          this.formData?.[field.valueKey] !== this.balance?.[field.valueKey];
        const isActiveChanged =
          this.formData?.[field.activeKey] !==
          this.balance?.[field.activeKey];

        return isValueChanged || isActiveChanged;
      });
    },
    fieldValues(): any {
      const values: any = {};
      this.fieldsConfig.forEach((field: any) => {
        Object.defineProperty(values, field.valueKey, {
          get: () => toPercents(this.formData[field.valueKey]),
          set: (value: number) => {
            this.formData[field.valueKey] = fromPercents(value);
          },
          enumerable: true,
          configurable: true
        });
      });
      return values;
    }
  },
  methods: {
    ...mapActions('OperatorPayments', ['saveOperatorBalance']),
    async handleOnFormSubmit(): Promise<void> {
      const form = this.$refs.form;

      await form.validate();

      if (!this.isFormValid) {
        return;
      }

      try {
        await this.saveOperatorBalance({
          ...this.balance,
          ...this.formData
        });

        this.$toast.success('Operator Fee has been updated');
      } catch (error) {
        errorToastMessage(error);
      } finally {
        this.confirmationDialogState = false;
      }
    }
  }
};
